import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// components
import About from './components/About/About.js';
import Header from './components/Header/Header.js';
import Home from './components/Home/Home.js';
import TXStateParks from './components/TXStateParks/TXStateParks.js';
import NationalParks from './components/NationalParks/NationalParks.js';
import Checklist from './components/Checklist/Checklist.js';
import Footer from './components/Footer/Footer.js';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/tx-state-parks" element={<TXStateParks />} />
        <Route path="/national-parks" element={<NationalParks />} />
        <Route path="/checklist" element={<Checklist />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;